import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faListMusic } from '@soundxyz/font-awesome/pro-regular-svg-icons/index.mjs';
import type { AddToPlaylistModalSource } from '@soundxyz/utils/analytics';
import { theme } from '@components-shared/src/stitches';
import { AddToPlaylistModal } from '@components/modals/AddToPlaylistModal/AddToPlaylistModal';
import { useAuth } from '@context/auth/base';
import { triggerLogin } from '@context/auth/store';
import { ModalContext, ModalType } from '@context/modal';
import { trackClickEvent } from '@lib/analytics';
import { DataTestId } from '@utils/test';
import { DropdownMenuItem, MenuItemLabel } from '../GlobalDropdown';

export const AddToShelfMenuItem = ({
  releaseId,
  disabled = false,
  source,
}: {
  releaseId?: string;
  disabled?: boolean;
  source: AddToPlaylistModalSource;
}) => {
  const { openModal } = ModalContext.useContainer();
  const { isAuthenticatedWithAPI } = useAuth();

  const onClick = () => {
    if (!isAuthenticatedWithAPI) {
      trackClickEvent({
        event: 'Sign in Clicked',
        properties: { sourceComponent: 'Add to Playlist Modal' },
      });
      triggerLogin();
      return;
    } else {
      if (!!releaseId) {
        trackClickEvent({
          event: 'Add to Playlist Clicked',
          properties: {
            sourceComponent: source,
            associationId: releaseId,
            associationType: 'Release',
          },
        });
        return openModal(ModalType.ADD_TO_PLAYLIST, {
          body: <AddToPlaylistModal releaseId={releaseId} />,
        });
      }
    }
  };

  return (
    <DropdownMenuItem
      onClick={onClick}
      disabled={disabled}
      data-testid={DataTestId.ADD_TO_SHELF_MENU_ITEM_DROPDOWN}
    >
      <FontAwesomeIcon
        icon={faListMusic}
        color={disabled ? theme.colors.neutral400.toString() : undefined}
        size="lg"
      />
      <MenuItemLabel>Add to playlist</MenuItemLabel>
    </DropdownMenuItem>
  );
};
